import React from "react";
import { Routes, Route } from "react-router-dom";
import SignIn from "../Pages/Login/SignIn";
import OTPVerification from "../Pages/Login/OTPVerification";
import ForgetPassword from "../Pages/Login/ForgetPassword";
import ChangePassword from "../Pages/Login/ChangePassword";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<SignIn />} />
      <Route path="otpVerification" element={<OTPVerification />} />
      <Route path="forgetPassword" element={<ForgetPassword />} />
      <Route path="changePassword" element={<ChangePassword />} />
    </Routes>
  );
};

export default AuthRoutes;
